import React, { useState } from "react";
import aboutHeroImg from "./assets/aboutpage.png";


// Assuming you have global CSS for classes like .container, .row, .col, 
// .shadow, .rounded-lg, .text-center, .text-primary, .bg-light, etc.

const FindUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone_number: "",
    message: "",
    email: ""
  });
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  // --- Form Handlers ---

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name || !formData.phone_number || !formData.message) {
      setStatus("Please fill all required fields (*).");
      return;
    }

    setLoading(true);
    setStatus("");

    try {
      const response = await fetch('https://tokenly.biswaas.com/api/master/contactpost', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: formData.name,
          phone_number: formData.phone_number,
          message: formData.message,
        })
      });

      const json = await response.json();

      if (response.ok) {
        setStatus("Thank you for contacting us. We will respond to your inquiry as soon as possible.");
        setFormData({ name: "", phone_number: "", message: "", email: "" });
        setTimeout(() => setStatus(""), 7000);
      } else {
        setStatus(json.message || "Something went wrong. Please try again.");
      }
    } catch (error) {
      setStatus("Network error. Please check your connection and try again.");
    } finally {
      setLoading(false);
    }
  };

  // --- Rendered Component (Improved UI) ---

  return (
    <>
      {/* Hero/Header Section */}
      <section
        className="position-relative d-flex align-items-center py-5"
        style={{
          minHeight: '260px',
          backgroundImage: `url(${aboutHeroImg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div
          style={{
            position: 'absolute',
            inset: 0,
            background: 'linear-gradient(135deg, rgba(15, 23, 42, 0.85), rgba(15, 23, 42, 0.6))',
            zIndex: 1
          }}
        ></div>
        <div className="container-fluid container-xl px-4 px-md-3 position-relative" style={{ zIndex: 2 }}>
          <h1 className="display-5 fw-bold text-white mb-1">Get In <span className="text-warning">Touch</span> With Tokenly</h1>
          <p className="text-light mb-0">
            Have a question, need assistance, or want to collaborate? The Tokenly team is here to support you.
          </p>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="display-6 fw-bold text-dark mb-3">Choose Your <span className="text-warning">Plan</span></h2>
            <p className="text-muted">Simple, transparent pricing for doctors of all sizes</p>
          </div>

          <div className="row g-4 justify-content-center">
            {/* Free Forever Plan */}
            <div className="col-lg-5 col-md-6">
              <div className="card h-100 shadow-sm border-0 rounded-4">
                <div className="card-body p-4 p-xl-5 text-center">
                  <div className="mb-3">
                    <i className="fas fa-gift text-warning fs-1"></i>
                  </div>
                  <h3 className="h4 fw-bold mb-2">Doctor's Free Forever Plan</h3>
                  <div className="display-6 fw-bold text-warning mb-3">₹0-For Doctors</div>
                  {/* <p className="text-muted mb-4">Doctor's Free Forever</p> */}
                  <ul className="list-unstyled text-start mb-4">
                    <li className="mb-3">
                      <i className="fas fa-check-circle text-success me-2"></i>
                      Start and continue at no cost, forever.
                    </li>
                    <li className="mb-3">
                      <i className="fas fa-check-circle text-success me-2"></i>
                      Zero Registration Fees - Now and Always
                    </li>
                    <li className="mb-3">
                      <i className="fas fa-check-circle text-success me-2"></i>
                      Accessible on All Platforms
                      <ul className="list-unstyled ms-4 mt-2">
                        <li><i className="far fa-circle text-primary me-2"></i>Android</li>
                        <li><i className="far fa-circle text-primary me-2"></i>iOS</li>
                        <li><i className="far fa-circle text-primary me-2"></i>Web (Desktop/Laptop)</li>
                      </ul>
                    </li>
                  </ul>
                  <p className="text-muted mb-4 text-start fst-italic small">
                    Note: Hardware devices Smart Display Device, Thermal Printer are not included and should be arranged by the doctor.
                  </p>

                  <button onClick={() => window.location.href = '/id-registration'} className="btn btn-outline-warning w-100 rounded-pill py-3 fw-bold">Get Started</button>
                </div>
              </div>
            </div>

            {/* Patient's Premium Plan */}
            <div className="col-lg-5 col-md-6">
              <div className="card h-100 shadow-sm border-0 rounded-4 highlight-card" style={{ border: '2px solid #ffc107' }}>
                <div className="card-body p-4 p-xl-5 text-center">
                  <div className="mb-3">
                    <i className="fas fa-crown text-warning fs-1"></i>
                  </div>
                  <h3 className="h4 fw-bold mb-2">Patinet's Premium Plan</h3>
                  <p className="text-muted mb-2">2 Free Token on Registration</p>
                  <div className="display-6 fw-bold text-warning mb-3">₹ 5 Per Token Hassle Free Token Booking</div>

                  <ul className="list-unstyled text-start mb-4">
                    <li className="mb-3">
                      <i className="fas fa-check-circle text-success me-2"></i>
                      Find Doctors Across The Country
                    </li>
                    <li className="mb-3">
                      <i className="fas fa-check-circle text-success me-2"></i>
                      Book Preferred Time Slot
                    </li>
                    <li className="mb-3">
                      <i className="fas fa-check-circle text-success me-2"></i>
                      Avoid queues
                    </li>
                    <li className="mb-3">
                      <i className="fas fa-check-circle text-success me-2"></i>
                      Priority customer support
                    </li>
                    <li className="mb-3">
                      <i className="fas fa-check-circle text-success me-2"></i>
                      Instant confirmation
                    </li>
                  </ul>

                  <a href="https://play.google.com/store/apps/details?id=com.doctorplus4" target="_blank" rel="noopener noreferrer" className="btn btn-warning w-100 rounded-pill py-3 fw-bold text-decoration-none">Download</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Main Contact Content Section - Two Columns (Form & Info) */}
      <section className="py-5 py-md-5">
        <div className="container">
          <div className="row g-5">

            {/* Contact Information Column */}
            <div className="col-lg-5">
              <h2 className="h3 fw-bold mb-4">Our Contact Details</h2>
              <p className="text-secondary mb-4">
                We're always ready to hear from you. Reach out via the channels below for general inquiries.
              </p>

              <div className="mb-4">
                <h4 className="h5 fw-semibold mb-2">Email Us</h4>
                <div className="d-flex align-items-center">
                  <i className="fas fa-envelope me-3 text-warning fs-5"></i>
                  <a
                    href="mailto:info@biswaas.com"
                    className="text-decoration-none text-dark"
                  >
                    info@biswaas.com
                  </a>
                </div>
              </div>

              <div className="mb-4">
                <h4 className="h5 fw-semibold mb-2">Call Us</h4>
                <div className="d-flex align-items-center">
                  <i className="fas fa-phone-alt me-3 text-warning fs-5"></i>
                  <span className="text-dark">+91-8130172666</span>
                </div>
              </div>

              <div className="mb-5">
                <h4 className="h5 fw-semibold mb-2">Find Us</h4>
                <div className="d-flex align-items-center">
                  <i className="fas fa-map-marker-alt me-3 text-warning fs-5"></i>
                  <a
                    href="https://www.google.com/maps/search/3016,+Masjid+Khajoor,+Dharampura,+Chandni+Chowk,+Delhi+-+110006/@28.653345,77.2297897,16.97z?entry=ttu&g_ep=EgoyMDI1MTEyMy4xIKXMDSoASAFQAw%3D%3D"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-decoration-none text-dark"
                  >
                    Chandni Chowk, Delhi - 110006
                  </a>
                </div>
              </div>

              {/* Specialized Inquiries (Optional, simplified) */}
              <h4 className="h5 fw-bold mb-3">Assistance in Any Department</h4>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <i className="bi bi-headset me-2 text-primary"></i>
                  <a href="mailto:support@biswaas.com" className="text-decoration-none text-secondary">
                    support@biswaas.com
                  </a>
                </li>
              </ul>
            </div>

            {/* Contact Form Column */}
            <div className="col-lg-7">
              <div className="p-4 p-md-5 shadow rounded-3 border bg-white">
                <h2 className="h3 fw-bold mb-4">Send Us A Message</h2>

                {/* Status Message Display */}
                {status && (
                  <div className={`alert ${status.includes("Thank you") ? "alert-success" : "alert-danger"} mb-4`} role="alert">
                    {status}
                  </div>
                )}

                {/* Contact Form */}
                <form onSubmit={handleSubmit}>

                  {/* Name Field */}
                  <div className="mb-3">
                    <label htmlFor="name" className="form-label fw-semibold">
                      Your Full Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      className="form-control"
                      placeholder="Full Name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  {/* Email & Phone Row */}
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="email" className="form-label fw-semibold">
                        Email Address (Optional)
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="john@example.com"
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-6 mt-3 mt-md-0">
                      <label htmlFor="phone_number" className="form-label fw-semibold">
                        Phone Number <span className="text-danger">*</span>
                      </label>
                      <input
                        type="tel"
                        id="phone_number"
                        name="phone_number"
                        className="form-control"
                        placeholder="+91..."
                        value={formData.phone_number}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  {/* Message/Query Field */}
                  <div className="mb-4">
                    <label htmlFor="message" className="form-label fw-semibold">
                      Your Query / Message <span className="text-danger">*</span>
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      className="form-control"
                      rows="4"
                      placeholder="Describe your issue or query here..."
                      value={formData.message}
                      onChange={handleChange}
                      required
                    ></textarea>
                  </div>

                  {/* Submit Button */}
                  <button
                    type="submit"
                    className="btn btn-warning btn-lg w-100 fw-bold"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Sending...
                      </>
                    ) : (
                      "Send Query"
                    )}
                  </button>
                </form>
              </div>
            </div>

          </div>
        </div>
      </section>


    </>
  );
};

export default FindUs;
